module.exports = __webpack_public_path__ + "img/bonhomme-jaune.0c1cb85d.png";